import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom/cjs/react-router-dom.min';
import { DoctariRoutes } from './DoctariRoutes';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
import Login from '../screens/login';
import RapidAppointment from '../screens/rapid-appointment';
import RapidAppointmentForm from '../screens/rapid-appointment/RapidAppointmentForm';
import VideoCallTest from '../screens/video-call-test';
import Checkout from '../screens/checkout';
import { CHECKOUT } from '../utils/urls';

const AppRouter = ({ session }) => {
  return (
    <Router>
      <div>
        <Switch>
          <PublicRoute
            exact
            path='/login'
            component={Login}
            isAuthenticated={session && session.email}
          />
          {/* <PublicRoute
            exact
            path='/rapid'
            component={RapidAppointment}
            isAuthenticated={session && session.email}
          /> */}
          {/* <PublicRoute
            exact
            path='/rapid/form'
            component={RapidAppointmentForm}
            isAuthenticated={session && session.email}
          /> */}
          <PublicRoute
            exact
            path='/video-test'
            component={VideoCallTest}
            isAuthenticated={session && session.email}
          />
          <Route exact path={CHECKOUT} component={Checkout} />

          <PrivateRoute
            path='/'
            component={DoctariRoutes}
            isAuthenticated={session && session.email}
          />
        </Switch>
      </div>
    </Router>
  );
};

const mapStateToProps = ({ session }) => {
  return {
    session,
  };
};

export default connect(mapStateToProps)(AppRouter);
